import React, { useEffect,useContext } from 'react';
import '../../styles/ContactBanner.css'
import Navbar from '../Navbar/Navbar';
import MenuContext from '../../Context/menuProvider'

function ContactBanner() {
    const {image,setImage,navbar} = useContext(MenuContext);



    useEffect(() => {
        if(navbar == true){
            setImage("img/Chiccone_Logo__.png")
        }else{
            setImage("img/Chiccone_Logo__white.png")
        }
      });
    return (
        <div className='ContactBanner'>
            <Navbar />
            <div className="container">
                <img src="img/Aboutbanner_bg.png" alt="Contact Banner" />
            </div>
            <div className="gradient">

            </div>
            <div className="text">
                <h2>Contact</h2>
            </div>

        </div>
    )
}

export default ContactBanner